import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY_REPORT } from "./apiRoutes";

interface UseGetPropertyReportExportProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyReportExport = async (data: any) =>
  await axiosAuth.post(`${PROPERTY_REPORT}/export`, data, {
    responseType: "blob",
  });

const useGetPropertyReportExport = ({
  data,
  queryParams,
}: UseGetPropertyReportExportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-report-export"],
    queryFn: () => getPropertyReportExport(data),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyReportExport;
